import angular from 'angular'
import template from './template.html'

export class NominasNominaInformacionAfComponent {
  constructor() {
    this.editando = false
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaInformacionAf', {
    controller: NominasNominaInformacionAfComponent,
    template: template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      indice: '<',
      calculado: '<',
      cerrado: '<',
      data: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/af/component.js